/**
 * estadosCobro.js · EL CATÁLOGO ÚNICO de estados de cobro y formas de pago.
 *
 * ═══════════════════════════ CONTRATO ═══════════════════════════
 * QUÉ ES: cómo se LLAMA y de qué COLOR se ve cada estado de un cobro, y cómo se
 *   escribe cada forma de pago. Para todas las pantallas que enseñen dinero.
 *
 * NO SE PUEDE CAMBIAR:
 *   · **Nadie vuelve a escribir su propia tabla de estados.** Se importa de aquí.
 *     Si falta un estado, se añade AQUÍ, y aparece en todas las pantallas a la vez.
 *   · **Un estado desconocido NO se pinta como si fuera normal.** Sale en rojo
 *     con «estado desconocido». Un valor nuevo que no estuviera aquí no fallaría:
 *     DESAPARECERÍA, que es peor.
 *
 * POR QUÉ EXISTE (01-10-2026): había TRES tablas distintas para lo mismo —la
 *   rejilla anual de clases fijas, el panel de taquillas de la ficha
 *   (`ClientNewProfile.jsx`) y el servidor— y la de la ficha llamaba «Pendiente»
 *   a lo que la otra llamaba «Generado». El mismo cobro, dos nombres, según la
 *   pantalla por la que entrases. Al montar la rejilla de taquillas habría nacido
 *   una CUARTA.
 * ════════════════════════════════════════════════════════════════
 */

// Catálogo OFICIAL de estados (Ann 2026-05-18 · ampliado PR-REJILLA-ESTADOS-1 2026-06-01)
export const EST = {
  registrado:          { l: "Generado",     c: "#2563eb", bg: "#eff6ff" },
  facturado:           { l: "Facturado",    c: "#7c3aed", bg: "#f5f3ff" },
  remesado:            { l: "Remesado",     c: "#0891b2", bg: "#ecfeff" },
  pendiente:           { l: "Pend SEPA",    c: "#d97706", bg: "#fffbeb" },
  confirmado:          { l: "Cobrado",      c: "#16a34a", bg: "#f0fdf4" },
  devuelto:            { l: "Devuelto",     c: "#dc2626", bg: "#fef2f2" },
  // Estados funcionales derivados (no persisten en BD)
  "re-cobrado":        { l: "Re-cobrado",   c: "#166534", bg: "#dcfce7" },
  "re-remesado":       { l: "Re-remesado",  c: "#6d28d9", bg: "#ede9fe" },
  cancelado:           { l: "Cancelado",    c: "#475569", bg: "#f1f5f9" },
  exento:              { l: "Exento",       c: "#166534", bg: "#dcfce7" },
  condonado:           { l: "Condonado",    c: "#475569", bg: "#f1f5f9" },
  // 'anulado' no se muestra en la rejilla mensual por diseño; en la ANUAL sí,
  // porque un año entero sin nada en su casilla no se distingue de un hueco.
  anulado:             { l: "Anulado",      c: "#475569", bg: "#f1f5f9" },
  // [Ann 2026-10-23] la empresa renuncia a cobrarlo (deuda incobrable): visible, en rojo oscuro, fuera del granate
  incobrable:          { l: "Incobrable",   c: "#7f1d1d", bg: "#fecaca" },
};

export const EST_HUECO_JUSTIFICADO = { l: "—",                            c: "#9ca3af", bg: "#f9fafb" };
export const EST_ERROR_NO_GENERADO = { l: "⚠️ ERROR · cobro no generado", c: "#ffffff", bg: "#dc2626" };
export const EST_ERROR_DESCONOCIDO = { l: "⚠️ ERROR · estado desconocido", c: "#ffffff", bg: "#dc2626" };

export const MET = { efectivo: "Efect.", tarjeta: "Tarj.", bizum: "Bizum", transferencia: "Transf.", domiciliacion: "Banco" };
export const MET_FULL = { efectivo: "Efectivo", tarjeta: "Tarjeta", bizum: "Bizum", transferencia: "Transferencia", domiciliacion: "Banco" };

/** El estilo de un estado. Un valor que no esté en el catálogo sale EN ROJO. */
export function estiloDeEstado(estado) {
  if (!estado) return EST_HUECO_JUSTIFICADO;
  return EST[estado] || EST_ERROR_DESCONOCIDO;
}
